import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DataObjectIcon from "@mui/icons-material/DataObject";
import BiotechIcon from "@mui/icons-material/Biotech";

const AiServiceCategories = ({ baseConfig }) => {
  const { tertColor } = baseConfig.siteBranding;

  const serviceCategories = [
    {
      id: 1,
      title: "Evaluating AI Applications",
      description:
        "Legal risk assessment, compliance evaluation, subcomponent license agreement analysis, input/output data analysis for legal and IP risk.",
      icon: <AssessmentIcon fontSize="large" />,
    },
    {
      id: 2,
      title: "Supporting AI Development",
      description:
        "Legal data labeling & annotation, prompt engineering for complex legal reasoning, legal agreements, and AI model integration services.",
      icon: <DataObjectIcon fontSize="large" />,
    },
    {
      id: 3,
      title: "AI in Patent Law",
      description:
        "AI-powered patent drafting, analysis, prior art searching, licensing target searching, and strategic IP planning.",
      icon: <BiotechIcon fontSize="large" />,
    },
  ];

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 2,
        backgroundColor: "#f0f7ff",
        mb: 4,
        border: `1px solid ${tertColor}33`,
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        gutterBottom
        sx={{ color: tertColor }}
      >
        Our AI Legal Services
      </Typography>
      <Typography variant="body1" paragraph>
        Kama Thuo, PLLC specializes in providing legal counsel across the
        following key areas of AI technology:
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        {serviceCategories.map((category) => (
          <Grid item xs={12} md={4} key={category.id}>
            <Paper
              elevation={1}
              sx={{
                p: 3,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                },
                border: `1px solid ${tertColor}22`,
                borderTop: `4px solid ${tertColor}`,
              }}
            >
              <Box sx={{ color: tertColor, mb: 2 }}>{category.icon}</Box>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                {category.title}
              </Typography>
              <Typography variant="body2">{category.description}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Typography variant="body2" sx={{ mt: 3, fontStyle: "italic" }}>
        Our team combines technical expertise with legal knowledge to provide
        comprehensive guidance tailored to your specific AI implementation
        needs.
      </Typography>
    </Box>
  );
};

export default AiServiceCategories;
